/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo__DescriptionInputs */

const en_seo__description = /** @type {(inputs: Seo__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter. Battle. Win. Join the excitement and experience the rush of victory, battle stategically in capped-player auctions.`)
};

/**
* | output |
* | --- |
* | "Enter. Battle. Win. Join the excitement and experience the rush of victory, battle stategically in capped-player auctions." |
*
* @param {Seo__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const seo__description = /** @type {((inputs?: Seo__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_seo__description(inputs)
});